module.exports = {
    by_funnel: {
        listener: '/recommendations/csr_fetch_personalized_content',
        fetcher: () => '/recommendations/csr_fetch_personalized_content',
    },
    by_section: {
        listener: '/recommendations/csr_fetch_personalized_content/section/:section_name',
        fetcher: (sectionName) => `/recommendations/csr_fetch_personalized_content/section/${sectionName}`,
        v5_fetcher: (sectionName) => `/recommendations/personalized_content/section/${sectionName}`,
    },
    by_component: {
        listener: '/recommendations/csr_fetch_personalized_content/section/:section_name/component/:component_name',
        fetcher: (sectionName, componentName) =>
            `/recommendations/csr_fetch_personalized_content/section/${sectionName}/component/${componentName}`,
    },
};
